// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"city-12"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17 21V11H7V21H17Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M21 21V6H15V11H17V21H21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M3 21H7V11H9V3H3V21Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 21V16M21 6V21H17V11H15V6H21ZM7 21H3V3H9V11H7V21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17 21V11H7V21H17Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const City12Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-12',
    ref,
    icon: element,
  },
));

City12Icon.displayName = 'City12Icon';

export default City12Icon;
